/**
 * SetupInMeetingService
 * Service for SetupInMeeting entity operations
 * Route: api/setupinmeetings
 * Controller: SetupInMeetingsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * SetupInMeetingService
 * Handles setup in meeting CRUD operations
 * Maps to /api/setupinmeetings endpoint
 */
export class SetupInMeetingService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SetupInMeetingService.DEFAULT_SERVICE_PATH,
            basePath: SetupInMeetingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
SetupInMeetingService.DEFAULT_SERVICE_PATH = 'meetings';
SetupInMeetingService.BASE_PATH = 'api/setupinmeetings';
//# sourceMappingURL=SetupInMeetingService.js.map